import firebase from 'firebase/app';
import 'firebase/firestore';
import { logger } from 'logging';

import { DocumentName, DefaultCollection } from './constants';
import { isCypress } from '../../../shared/helpers/utils/cypress';

interface Config {
  [key: string]: string;
}

export const listenCloudStore = (
  config: Config,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  actionCB: (data: any) => Promise<void>
) => {
  try {
    if (firebase && !isCypress()) {
      if (!firebase.apps.length) {
        firebase.initializeApp(config || {});
      }
      const dataBaseRef = firebase.firestore();
      if (dataBaseRef) {
        const fireStoreCollection = config?.collection || DefaultCollection;
        const docName = config?.doc || DocumentName;
        const docRef = dataBaseRef.collection(fireStoreCollection).doc(docName);
        docRef.onSnapshot(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (doc: any) => {
            const data = doc.data();
            if (data) {
              // eslint-disable-next-line no-console
              console.log('[Firestore] VP data received:', Object.keys(data));
              actionCB && actionCB(data);
            } else {
              logger.warn('Firestore VP document exists but has no data');
            }
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (error: any) => {
            logger.error(error, 'Error in Firestore VP listener snapshot');
          }
        );
      }
    }
  } catch (e) {
    logger.error(e, 'Error in firebase listener');
  }
};
